import React, { useState } from "react";

export const UserForm = ({ user, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    prenom: user.prenom || "",
    nom: user.nom || "",
    email: user.email || "",
    adresse: user.adresse || "",
    code_postal: user.code_postal || "",
    ville: user.ville || "",
    telephone: user.telephone || "",
    role: user.role || ["ROLE_USER"],
    id: user.id,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="admin-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Prénom</label>
          <input
            type="text"
            value={formData.prenom}
            onChange={(e) =>
              setFormData({ ...formData, prenom: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Nom</label>
          <input
            type="text"
            value={formData.nom}
            onChange={(e) => setFormData({ ...formData, nom: e.target.value })}
            required
          />
        </div>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) =>
              setFormData({ ...formData, email: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Adresse</label>
          <input
            type="text"
            value={formData.adresse}
            onChange={(e) =>
              setFormData({ ...formData, adresse: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Code Postal</label>
          <input
            type="text"
            value={formData.code_postal}
            onChange={(e) =>
              setFormData({ ...formData, code_postal: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Ville</label>
          <input
            type="text"
            value={formData.ville}
            onChange={(e) =>
              setFormData({ ...formData, ville: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Téléphone</label>
          <input
            type="tel"
            value={formData.telephone}
            onChange={(e) =>
              setFormData({ ...formData, telephone: e.target.value })
            }
            required
          />
        </div>
        <div className="form-group">
          <label>Rôle</label>
          <select
            value={formData.role[0]}
            onChange={(e) =>
              setFormData({ ...formData, role: [e.target.value] })
            }
          >
            <option value="ROLE_USER">Utilisateur</option>
            <option value="ROLE_ADMIN">Administrateur</option>
          </select>
        </div>
        <div className="form-actions">
          <button type="submit" className="btn-save">
            Enregistrer
          </button>
          <button type="button" className="btn-cancel" onClick={onCancel}>
            Annuler
          </button>
        </div>
      </form>
    </div>
  );
};
